import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { SubwayInfo as SubwayInfoComponent } from '../../components/SubwayInfo';
import { ISubwayInfo } from '../../types/subway';
import { metroIconMap, transportIconMap } from './helpers';
import { TDeprecatedColors } from '@cian/ui-kit-design-tokens/colors/deprecated';

type TThemeType = 'standard' | 'light';

interface ISubwayInfoProps {
  subwayInfo?: ISubwayInfo | null;
  theme?: TThemeType;
}

const titleThemeMap: Record<TThemeType, TColors> = {
  standard: 'theme-dark',
  light: 'theme-white',
};

// TDeprecatedColors - используется, т.к нет похожего цвета (white_60) в TColors
const timeThemeMap: Record<TThemeType, TColors | TDeprecatedColors> = {
  standard: 'text-secondary-default',
  light: 'white_60',
};

export function SubwayInfo({ subwayInfo, theme = 'standard' }: ISubwayInfoProps) {
  if (!subwayInfo) {
    return null;
  }

  const TransportIcon = transportIconMap[subwayInfo.transportType];
  const MetroIcon = metroIconMap.default;

  return (
    <SubwayInfoComponent
      subwayIcon={<MetroIcon color={subwayInfo.lineColor as TColors} />}
      subwayColor={`#${subwayInfo.lineColor}`}
      title={<ArticleParagraph2 color={titleThemeMap[theme]}>{subwayInfo.name}</ArticleParagraph2>}
      typeIcon={<TransportIcon />}
      time={<ArticleParagraph2 color={timeThemeMap[theme]}>{subwayInfo.timeDisplay}</ArticleParagraph2>}
    />
  );
}
